export default "{{result}}\r\n";